import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/app/kit";

export default function TabsPage({ eyebrow, title, subtitle, tabs, actions, testid }) {
  const visible = tabs.filter((t) => t.show !== false);
  return (
    <div data-testid={testid}>
      <PageHeader eyebrow={eyebrow} title={title} subtitle={subtitle} actions={actions} />
      <Tabs defaultValue={visible[0]?.v} className="animate-fade-up">
        <TabsList className="flex-wrap h-auto justify-start bg-slate-100">
          {visible.map((t) => <TabsTrigger key={t.v} value={t.v} data-testid={`tab-${t.v}`}>{t.label}</TabsTrigger>)}
        </TabsList>
        {visible.map((t) => <TabsContent key={t.v} value={t.v} className="mt-5">{t.el}</TabsContent>)}
      </Tabs>
    </div>
  );
}
